import {Component, OnInit, ViewChild} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material';
import {FormControl, FormGroup} from '@angular/forms';
import {ApprovalPending} from '../shared/dto/approval-pending';
import {MatTableDataSource} from '@angular/material/table';
import {ActivatedRoute} from '@angular/router';
import {TokenStorageService} from '../shared/service/token-storage.service';
import {SuspendBlacklistService} from '../shared/service/suspend-blacklist.service';

@Component({
  selector: 'app-suspend-blacklist-process',
  templateUrl: './suspend-blacklist-process.component.html',
  styleUrls: ['./suspend-blacklist-process.component.scss']
})
export class SuspendBlacklistProcessComponent implements OnInit {
  public userName: string;
  public type: string;
  blacklistForm: FormGroup;
  public approvalPendingList: ApprovalPending[];
  approvalPending: ApprovalPending = new ApprovalPending();
  displayedColumns: string[] = ['refNo', 'nic', 'name', 'cdc' ,'stage', 'createdDate', 'action'];
  dataSource: MatTableDataSource<any>;

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;


  constructor(private route: ActivatedRoute, private suspendBlacklistService: SuspendBlacklistService,
              private tokenStorageService: TokenStorageService) {
    this.route.paramMap.subscribe(params => {
      this.type = params.get('type');
    });
    this.userName=this.tokenStorageService.getUserObjectToken().username;
  }

  ngOnInit() {
    this.blacklistForm = new FormGroup({
      appRefNo: new FormControl(null),
      name: new FormControl(null),
      nic: new FormControl(null),
      cdcNo: new FormControl(null),
    });

    this.getAllRequestDetails();
  }

  setBase64(code: string): string {
    return btoa(code);
  }

  getAllRequestDetails(){
    this.approvalPending.appRefNo = this.blacklistForm.value.appRefNo;
    this.approvalPending.cdcNo = this.blacklistForm.value.cdcNo;
    this.approvalPending.name = this.blacklistForm.value.name;
    this.approvalPending.nic = this.blacklistForm.value.nic;
    this.approvalPending.loginUser = this.userName;
    this.approvalPending.type = this.type;
    this.suspendBlacklistService.getAllReturnRequestData(this.approvalPending).subscribe(
      (result: ApprovalPending[]) => {
        this.approvalPendingList = result;
        this.dataSource = new MatTableDataSource(this.approvalPendingList);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    )
  }

}
